// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"clientAssessmentRoute_backIcon__1qjBA","container":"clientAssessmentRoute_container__3VVaG","stage":"clientAssessmentRoute_stage__qf0q0"};